<template>
  <div class="custom-callout-wrapper">
    <div v-if="showCSEELabel" class="custom-upper-panel rounded-top">
      <span class="color-gray-6 font-14">CSEE/ORE:&nbsp;</span>
      <span class="color-black font-16 font-weight-bold">
        {{ item.centerName | capitalize }}
      </span>
    </div>
    <custom-callout
      has-toggle
      :controlled="true"
      :border-color="getColor"
      :opened="activeIndex === index"
      @click:open="onTogglePanelCallout"
    >
      <div class="row mx-auto py-2">
        <div class="status divider-right col-sm-12 col-md-2">
          <custom-balloon
            class="w-100"
            :text="item.statusName"
            :background-color="getColor"
          />
        </div>
        <div class="row m-0 col-md-8 p-0">
          <div class="data-col col-sm-12 col-md-3">
            <span class="color-gray-6 font-14">
              Número de Certificación de CSEE:
            </span>
            <span class="color-black font-16">
              {{ item.certificationNumber }}
            </span>
          </div>
          <div class="data-col col-sm-12 col-md-3">
            <span class="color-gray-6 font-14">
              Cantidad de Escuelas a Certificar:
            </span>
            <span class="color-black font-16">
              {{ item.schoolsToCertifyCount }}
            </span>
          </div>
          <div class="data-col col-sm-12 col-md-3">
            <span class="color-gray-6 font-14">
              Cantidad de Escuelas Certificadas:
            </span>
            <span class="color-black font-16">
              {{ item.certifiedSchoolsCount }}
            </span>
          </div>
          <div class="data-col col-sm-12 col-md-3">
            <span class="color-gray-6 font-14">
              Cantidad de Egresos en Certificación:
            </span>
            <span class="color-black font-16">
              {{ item.certificationStudentsCount }}
            </span>
          </div>
        </div>
        <div
          class="col-md-2 d-flex align-items-center justify-content-end pr-3"
        >
          <DropDown
            v-if="getMenuItems.length"
            :items="getMenuItems"
            normal-size
          />
        </div>
      </div>
      <template #edition>
        <div
          v-if="selectedPanelType === panelTypes.UploadSignedCertification"
          class="upload-ore-document-panel row mx-auto p-4"
        >
          <div class="col-12 p-0">
            <icon-view
              :has-border="false"
              icon="fas fa-file-plus color-orange"
              icon-size="1rem"
              title="Anejar Certificación Firmada"
              variant="custom-icon-view"
              icon-background="white"
            />
          </div>
          <div
            class="col-12 row mx-auto document-panel bg-white px-2 py-3 mt-3"
          >
            <div class="col-sm-12 col-md-4 data-col">
              <span class="color-gray-6 font-14">Tipo de Documento:</span>
              <span class="color-black font-14 font-weight-bold">
                Reporte Certificación Egreso ORE - Firmado
              </span>
            </div>
            <div class="col-sm-12 col-md-4 data-col">
              <span class="color-gray-6 font-14">Archivo:</span>
              <span class="color-black font-14 font-weight-bold">
                {{ displayDocumentName | empty }}
              </span>
            </div>
            <div
              class="col-sm-12 col-md-4 d-flex align-items-center justify-content-end"
            >
              <custom-file-input
                id="ore-document-upload"
                ref="ore-document-upload"
                display-style="normal"
                :accept="'.pdf'"
                :attachment-id="documentAttachmentId"
                :on-download="onDownloadDocumentOre"
                :disabled="false"
                @input="onChangeDocumentOre"
              />
            </div>
          </div>
          <div
            class="action-buttons col-12 d-flex justify-content-end mt-4 p-0"
          >
            <action-button
              text="Cancelar"
              i="fa fa-times-circle"
              variant="outline-danger"
              @click="onHidePanel"
            />
            <action-button
              text="Guardar"
              i="fas fa-save"
              variant="success"
              class="ml-2"
              @click="onUploadDocumentOre"
            />
          </div>
        </div>
        <OreStatusTimeLine
          v-if="selectedPanelType === panelTypes.OreCertificationStatusHistory"
          class="ore-status-history-panel"
          :records="statusHistoryRecords"
          @hide="() => setActiveIndex(null)"
        />
        <div
          v-if="selectedPanelType === panelTypes.DenyCertification"
          class="deny-status-section-wrapper row mx-auto p-2"
        >
          <div class="deny-status-comment col-12 row mx-auto p-3 bg-white">
            <div class="col-12">
              <em class="fas fa-times-circle text-danger mr-2" />
              <span class="color-gray-7 font-16">Denegar</span>
            </div>
            <validation-observer class="col-12" ref="denyStatusFormValidator">
              <div class="d-flex flex-direction mt-3">
                <validation-provider
                  v-slot="{ errors }"
                  class="flex-grow-2"
                  rules="required"
                >
                  <div>
                    <label class="input-label">Comentario:</label>
                    <CustomTextArea
                      type="text"
                      v-model="denyComment"
                      :show-char-count="true"
                      :error="errors[0]"
                      :custom-error-msg="messages['0675']"
                      :maxlength="3000"
                    />
                  </div>
                </validation-provider>
              </div>
            </validation-observer>
            <div class="col-12 d-flex justify-content-end mt-4">
              <action-button
                variant="danger mr-2"
                i="fas fa-times-circle"
                text="Cancelar"
                @click="onResetPanel"
              />
              <action-button
                variant="success mr-2"
                i="fas fa-save"
                text="Guardar"
                @click="onSaveDenyStatusComment"
              />
            </div>
          </div>
        </div>
        <div
          v-if="selectedPanelType === panelTypes.ChangeToNotSubmitted"
          class="change-to-not-submitted-section-wrapper row mx-auto p-2"
        >
          <div
            class="change-to-not-submitted-comment col-12 row mx-auto p-3 bg-white"
          >
            <div class="col-12">
              <em class="fas fa-undo-alt text-orange mr-2" />
              <span class="color-gray-7 font-16">Cambiar a No Sometido</span>
            </div>
            <validation-observer
              class="col-12"
              ref="notSubmittedFormValidator"
            >
              <div class="d-flex flex-direction mt-3">
                <validation-provider
                  v-slot="{ errors }"
                  class="flex-grow-2"
                  rules="required"
                >
                  <div>
                    <label class="input-label">Comentario:</label>
                    <CustomTextArea
                      type="text"
                      v-model="notSubmittedComment"
                      :show-char-count="true"
                      :error="errors[0]"
                      :custom-error-msg="messages['0675']"
                      :maxlength="3000"
                    />
                  </div>
                </validation-provider>
              </div>
            </validation-observer>
            <div class="col-12 d-flex justify-content-end mt-4">
              <action-button
                variant="danger mr-2"
                i="fas fa-times-circle"
                text="Cancelar"
                @click="onResetPanel"
              />
              <action-button
                variant="success mr-2"
                i="fas fa-save"
                text="Guardar"
                @click="onSaveChangeToNotSubmittedComment"
              />
            </div>
          </div>
        </div>
      </template>
    </custom-callout>
  </div>
</template>

<script>
import CustomBalloon from '@/components/common/CustomBalloon.vue';
import CustomCallout from 'custom-callout';
import DropDown from 'dropdown';
import CustomFileInput from 'CustomFileInput';
import IconView from 'icon-view';
import OreStatusTimeLine from './OreStatusTimeLine';
import CustomTextArea from '@/components/common/CustomTextArea';
import alert from '@/mixin/alert.mixin';
import store from '@/store/index';
import statusEnum from '@/utils/constants/student/childCountOreStatusEnum';
import { ActionButton } from '@/components/common';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { Colors } from '../../common';
import {
  uploadCertification as _uploadCertification,
  validateIsCertificationApprovable as _validateIsCertificationApprovable,
  switchCertificationStatus as _switchCertificationStatus,
  getCertificationStatusHistory as _getCertificationStatusHistory,
  setNotSubmitted as _setNotSubmitted,
} from '@/services/api/certificationOre.api.js';
import documentsService from '@/services/documents';
import reportService from '@/services/report';
import childCountOreStatusEnum from '@/utils/constants/student/childCountOreStatusEnum';
import { capitalize } from '@/utils/filters';
import documentTypes from '@/utils/constants/documentTypes.js';

export default {
  name: 'RowChildCountOre',
  mixins: [alert],
  components: {
    CustomCallout,
    CustomBalloon,
    ActionButton,
    DropDown,
    CustomFileInput,
    IconView,
    OreStatusTimeLine,
    CustomTextArea,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    index: {
      type: Number,
      required: true,
    },
    activeIndex: {
      type: Number,
      default: null,
    },
    option: {
      type: Object,
      required: true,
    },
    messages: {
      type: Object,
      default: () => [],
    },
    showCSEELabel: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      documentModel: null,
      selectedPanelType: null,
      statusHistoryRecords: [],
      denyComment: null,
      notSubmittedComment: null,
    };
  },
  computed: {
    item() {
      return this.option;
    },
    getColor() {
      switch (this.item.statusId) {
        case statusEnum.notSubmitted:
          return Colors.GRAY;
        case statusEnum.submitted:
          return Colors.YELLOW;
        case statusEnum.approved:
          return Colors.GREEN;
        case statusEnum.denied:
          return Colors.BROWN;
      }

      return '';
    },
    getMenuItems() {
      let result = [
        {
          label: 'Someter',
          icon: 'fas fa-flag text-green',
          visible: this.isNotSubmitted,
          click: () => this.submitCertification(),
        },
        {
          label: 'Anejar Certificación Firmada',
          icon: 'fas fa-file-plus text-green',
          visible: this.isNotSubmitted && !this.documentAttachmentId,
          click: () =>
            this.setActiveIndex(
              this.index,
              this.panelTypes.UploadSignedCertification
            ),
        },
        {
          label: 'Imprimir Certificación',
          icon: 'fas fa-print text-green',
          visible: true,
          click: this.downloadCertificationReport,
        },
        {
          label: 'Imprimir Certificación Anejada',
          icon: 'fas fa-print text-green',
          visible: !!this.documentAttachmentId,
          click: () => this.onDownloadDocumentOre(this.documentAttachmentId),
        },
        {
          label: 'Regresar Estatus',
          icon: 'fas fa-reply-all text-green',
          visible: this.hasRevertPermission && !this.isNotSubmitted,
          click: this.revertStatusHandler,
        },
        {
          label: 'Cambiar a No Sometido',
          icon: 'fas fa-undo-alt text-orange',
          visible: this.canChangeToNotSubmitted && !this.isNotSubmitted,
          click: () =>
            this.setActiveIndex(
              this.index,
              this.panelTypes.ChangeToNotSubmitted
            ),
        },
        {
          label: 'Aprobar',
          icon: 'fas fa-check-circle text-green',
          visible: this.hasApprovePermission && this.isSubmitted,
          click: () => this.switchStatusHandler(statusEnum.approved),
        },
        {
          label: 'Denegar',
          icon: 'fas fa-times-circle text-danger',
          visible: this.hasDenyPermission && this.isSubmitted,
          click: () =>
            this.setActiveIndex(this.index, this.panelTypes.DenyCertification),
        },
        {
          label: 'Historial',
          icon: 'fas fa-clock text-orange',
          visible: true,
          click: () =>
            this.setActiveIndex(
              this.index,
              this.panelTypes.OreCertificationStatusHistory
            ),
        },
      ];

      return result;
    },
    documentAttachmentId() {
      return this.option.documentOre?.id;
    },
    displayDocumentName() {
      return this.documentModel?.name || this.option.documentOre?.name;
    },
    isNotSubmitted() {
      return this.option.statusId === childCountOreStatusEnum.notSubmitted;
    },
    isSubmitted() {
      return this.option.statusId === childCountOreStatusEnum.submitted;
    },
    hasRevertPermission() {
      return store.getters.HasPermission(
        'academic.student.exitcertification.orelevel.reverse'
      );
    },
    hasApprovePermission() {
      return store.getters.HasPermission(
        'academic.student.exitcertification.orelevel.approve'
      );
    },
    hasDenyPermission() {
      return store.getters.HasPermission(
        'academic.student.exitcertification.orelevel.deny'
      );
    },
    canChangeToNotSubmitted() {
      return store.getters.HasPermission(
        'academic.student.graduationcertification.setnotsubmitted'
      );
    },
    panelTypes() {
      return {
        UploadSignedCertification: 1,
        OreCertificationStatusHistory: 2,
        DenyCertification: 3,
        ChangeToNotSubmitted: 4,
      };
    },
  },
  methods: {
    setActiveIndex(index, panelType = null) {
      let newIndex = index;
      this.selectedPanelType = panelType;

      if (index && !panelType) {
        newIndex = null;
      }

      this.$emit('on-set-active-index', newIndex);
    },
    async onDownloadDocumentOre(documentId) {
      await documentsService.downloadFromServer(documentId);
    },
    async downloadCertificationReport() {
      const params = {
        academicYearId: this.option?.academicYearId || 0,
        centerId: this.option?.centerId || 0,
      };
      await reportService.downloadCertificationEgress(params);
    },
    async onChangeDocumentOre(file) {
      this.documentModel = file;
    },
    onHidePanel() {
      this.documentModel = null;
      this.setActiveIndex(null);
    },
    onResetPanel() {
      this.onHidePanel();
      this.denyComment = null;
      this.notSubmittedComment = null;
    },
    onTogglePanelCallout() {
      if (this.activeIndex === this.index) {
        this.onHidePanel();
        return;
      }

      this.setActiveIndex(
        this.index,
        this.panelTypes.UploadSignedCertification
      );
    },
    async submitCertification() {
      const answerResult = await this.ShowCancelModal(
        'Aviso',
        '¿Esta seguro desea someter certificación?',
        'Sí',
        'No'
      );

      if (!answerResult) return;

      if (!this.item.documentOre) {
        this.ShowToast(
          'Error',
          'No se puede someter hasta que todas las certificaciones tengan el Reporte Certificación Egreso ORE anejado',
          'error'
        );
        this.setActiveIndex(
          this.index,
          this.panelTypes.UploadSignedCertification
        );
        return;
      }

      const {
        data: allSchoolCertificationsApproved,
      } = await _validateIsCertificationApprovable(
        this.item.certificationOreId
      );
      if (!allSchoolCertificationsApproved) {
        this.ShowToast(
          'Error',
          'No se puede someter hasta que todas las certificaciones estén aprobadas',
          'error'
        );
        return;
      }

      try {
        const payload = {
          certificationOreId: this.item.certificationOreId,
          isRevertStatus: false,
          newStatusId: statusEnum.submitted,
        };

        const { data: isUpdated } = await _switchCertificationStatus(payload);

        if (!isUpdated) return;

        this.ShowToast(
          'Proceso Exitoso',
          'Certificación sometida exitosamente.',
          this.toastType.Success
        );
        this.$emit('update-row-result');
      } catch (err) {
        this.ShowToast('Error', err.response.data.message, 'error');
      }
    },
    async onUploadDocumentOre() {
      const formData = new FormData();
      formData.append(
        `input.certificationOreId`,
        this.item.certificationOreId ?? ''
      );
      formData.append(
        `input.documentTypeId`,
        documentTypes.Certification_ORE_Egress
      );
      formData.append(`input.certificationDocument`, this.documentModel ?? '');

      try {
        await _uploadCertification(formData);

        this.$emit('update-row-result');

        this.onHidePanel();

        this.ShowToast(
          'Proceso Exitoso.',
          'El documento ha sido actualizado exitosamente.',
          this.toastType.Success
        );
      } catch (err) {
        this.ShowToast('', err.response.data.message, 'error');
      }
    },
    async revertStatusHandler() {
      const payload = {
        certificationOreId: this.item.certificationOreId,
        isRevertStatus: true,
      };
      const certificationCenterName = capitalize(this.item.centerName);
      const confirmed = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea revertir el estatus de la certificación ${this.item.certificationNumber} correspondiente al CSEE ${certificationCenterName}?`,
        'Sí',
        'No'
      );

      if (!confirmed) return;

      const { data: isReverted } = await _switchCertificationStatus(payload);

      if (!isReverted) return;

      this.ShowToast(
        'Proceso Existoso',
        'El estatus de la certificación se ha revertido exitosamente.',
        this.toastType.Success
      );

      // reload history data
      await this.searchOreStatusHistoryData();

      this.$emit('update-row-result');
    },
    async switchStatusHandler(newStatusId, config = null) {
      const certificationCenterName = capitalize(this.item.centerName);

      if (statusEnum.approved == newStatusId) {
        const confirmed = await this.ShowCancelModal(
          'Confirmación',
          `¿Está seguro que desea aprobar la certificación ${this.item.certificationNumber} correspondiente al CSEE ${certificationCenterName}?`,
          'Sí',
          'No'
        );

        if (!confirmed) return;
      }

      config = config
        ? config
        : {
            successTitle: 'Proceso Existoso',
            successMessage:
              'El estatus de la certificación se ha actualizado exitosamente.',
          };

      const payload = {
        certificationOreId: this.item.certificationOreId,
        isRevertStatus: false,
        newStatusId,
        comment: this.denyComment,
      };

      try {
        const { data: isUpdated } = await _switchCertificationStatus(payload);

        if (!isUpdated) return;

        this.ShowToast(
          config.successTitle || '',
          config.successMessage || '',
          this.toastType.Success
        );

        // reload history data
        await this.searchOreStatusHistoryData();

        this.$emit('update-row-result');

        this.onResetPanel();
      } catch (err) {
        this.ShowToast(
          '',
          err?.response?.data?.message || err?.message || 'Error',
          this.toastType.Error
        );
      }
    },
    async searchOreStatusHistoryData() {
      const params = {
        certificationOreId: this.item.certificationOreId,
        pageIndex: 1,
        pageSize: 1999999999,
      };
      const {
        data: statusHistoryPagination,
      } = await _getCertificationStatusHistory(params);
      this.statusHistoryRecords = statusHistoryPagination?.data || [];
    },
    async onSaveDenyStatusComment() {
      if (!this.denyComment?.trim()) {
        await this.$refs?.denyStatusFormValidator?.validate();
        this.ShowToast('Alerta', this.messages['R150007'], 'error');
        return;
      }

      const certificationCenterName = capitalize(this.item.centerName);
      const title =
        this.messages['R90020']?.replace(
          '{0}',
          this.item.certificationNumber
        ) || 'Aviso';
      const message =
        this.messages['US111582']
          ?.replace('{0}', this.item.certificationNumber)
          .replace('{1}', certificationCenterName) ||
        `¿Está seguro que desea denegar la certificación ${this.item.certificationNumber} correspondiente al CSEE ${certificationCenterName}?`;

      const confirmation = await this.ShowCancelModal(title, message);

      if (!confirmation) return;

      const config = {
        successTitle: 'Completado',
        successMessage: 'Su información ha sido completada exitosamente.',
      };

      await this.switchStatusHandler(statusEnum.denied, config);
    },
    async onSaveChangeToNotSubmittedComment() {
      if (!this.notSubmittedComment?.trim()) {
        await this.$refs?.notSubmittedFormValidator?.validate();
        this.ShowToast('Alerta', this.messages['R150008'], 'error');
        return;
      }

      const certificationCenterName = capitalize(this.item.centerName);
      const confirmation = await this.ShowCancelModal(
        'Aviso',
        `¿Está seguro que desea cambiar el estatus de la certificación ${this.item.certificationNumber} correspondiente al CSEE ${certificationCenterName} a No Sometido?`
      );

      if (!confirmation) return;

      try {
        await _setNotSubmitted({
          certificationOreId: this.item.certificationOreId,
          comment: this.notSubmittedComment,
        });

        this.ShowToast(
          'Completado',
          'Se realizó el cambio de estatus exitosamente.',
          this.toastType.Success
        );

        // reload history data
        await this.searchOreStatusHistoryData();

        this.$emit('update-row-result');

        this.onResetPanel();
      } catch (err) {
        this.ShowToast(
          '',
          err?.response?.data?.message || err?.message || 'Error',
          this.toastType.Error
        );
      }
    },
  },
  watch: {
    selectedPanelType: {
      async handler(val) {
        if (val === this.panelTypes.OreCertificationStatusHistory) {
          await this.searchOreStatusHistoryData();
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables/_colors.scss';

$border-gray-light: #eaeaea;
$gray-mint: #ebf1ee;

.custom-upper-panel {
  padding: 10px;
  background-color: $gray-mint;
}
.status {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding-left: 0px;
}
.divider-right {
  padding-right: 20px;
  border-right: 1px solid $border-gray-light;
}
.data-col {
  display: flex;
  flex-direction: column;
}
.document-panel {
  border-left: 4px solid map-get($colors, 'gray-2');
}
.custom-icon-view {
  &:deep(.dot) {
    .title-icon {
      padding-top: 4px;
    }
  }

  &:deep(.color-gray-7) {
    color: map-get($colors, 'black') !important;
  }
}
.green {
  background-color: #a4e5b2 !important;
}
</style>
